{
  "resourceType": "Patient",
  "id": "egGyIWPo4yhJaPp9aOEPUPg3",
  "extension": [
    {
      "extension": [
        {
          "valueCoding": {
            "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
            "code": "UNK",
            "display": "Unknown"
          },
          "url": "ombCategory"
        },
        { "valueString": "Unknown", "url": "text" }
      ],
      "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
    },
    {
      "extension": [{ "valueString": "Unknown", "url": "text" }],
      "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
    },
    {
      "valueCodeableConcept": {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.698084.130.657370.19999000",
            "code": "female",
            "display": "female"
          }
        ]
      },
      "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
    },
    {
      "valueCodeableConcept": {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.0.1.7.10.698084.130.657370.19999000",
            "code": "female",
            "display": "female"
          }
        ]
      },
      "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use"
    },
    {
      "valueCode": "F",
      "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-birthsex"
    }
  ],
  "identifier": [
    {
      "use": "usual",
      "system": "urn:oid:2.16.840.1.113883.4.1",
      "value": "269-25-8523"
    },
    {
      "use": "usual",
      "type": { "text": "CEID" },
      "system": "urn:epic:apporchard.curprod",
      "value": "AO15BDG23N3FPS8"
    },
    {
      "use": "usual",
      "type": { "text": "EPIC" },
      "system": "urn:oid:1.2.840.114350.1.1",
      "value": "E4586"
    },
    {
      "use": "usual",
      "type": { "text": "EXTERNAL" },
      "system": "urn:oid:1.2.840.114350.1.13.0.1.7.2.698084",
      "value": "Z6675"
    },
    {
      "use": "usual",
      "type": { "text": "FHIR" },
      "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
      "value": "To2M6bY3SxUxrkDTET79QuYvDoFmDlQLEJnoOi2YrZ0AB"
    },
    {
      "use": "usual",
      "type": { "text": "FHIR STU3" },
      "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
      "value": "egGyIWPo4yhJaPp9aOEPUPg3"
    },
    {
      "use": "usual",
      "type": { "text": "INTERNAL" },
      "system": "urn:oid:1.2.840.114350.1.13.0.1.7.2.698084",
      "value": "     Z6675"
    },
    {
      "use": "usual",
      "type": { "text": "MRN" },
      "system": "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.14",
      "value": "204246"
    }
  ],
  "active": true,
  "name": [
    {
      "use": "official",
      "text": "Kelly Beacon",
      "family": "Beacon",
      "given": ["Kelly"]
    },
    {
      "use": "usual",
      "text": "Kelly Beacon",
      "family": "Beacon",
      "given": ["Kelly"]
    }
  ],
  "gender": "female",
  "birthDate": "1970-02-04",
  "deceasedBoolean": false,
  "generalPractitioner": [
    {
      "reference": "Practitioner/eM5CWtq15N0WJeuCet5bJlQ1",
      "type": "Practitioner",
      "display": "Physician Family Medicine, prac1"
    },
    {
      "reference": "Practitioner/eM5CWtq15N0WJeuCet5bJlQ2",
      "type": "Practitioner",
      "display": "Physician Family Medicine, prac2"
    },
    {
      "reference": "Practitioner/eM5CWtq15N0WJeuCet5bJlQ3",
      "type": "Practitioner",
      "display": "Physician Family Medicine, prac3"
    },
    {
      "reference": "Practitioner/eM5CWtq15N0WJeuCet5bJlQ4",
      "type": "Practitioner",
      "display": "Physician Family Medicine, prac4"
    }
  ],
  "managingOrganization": {
    "reference": "Organization/enRyWnSP963FYDpoks4NHOA1",
    "display": "Epic Hospital System"
  },
  "link": [
    {
      "reference": "Patient/enRyWnSP963FYDpoks4NHOB1",
      "display": "patient1"
    },
    {
      "reference": "Patient/enRyWnSP963FYDpoks4NHOB2",
      "display": "patient2"
    },
    {
      "reference": "Patient/enRyWnSP963FYDpoks4NHOB3",
      "display": "patient3"
    }
  ]
}
